import styled from '@emotion/styled';

const Fifth:React.FC<any> = () => {
  const handleProduct = () => {
    window.location.href="/product"
  }

  return (
    // <Container>
    //   {/* <Title className="top">신경쓸 것 많은 <br/> 당신에게 필수!<br/> 손쉬운 사진 관리 패키지</Title> */}
    //   <Title className="top">구성품</Title>
    //   <BodyImg>
    //     <Img src="/images/newLanding/home/product.png"/>
    //   </BodyImg>
    //   <Title className="bottom">신경 써야 할  <br/>모든 걸 한 번에<br/>인화구독 패키지</Title>
    //   <SmallText>앨범, 속지, 인화까지 고민없이 <br/> 시작 시 앨범을,<br/> 매달 사진과 속지를 드려요.</SmallText>
    //   <MoreButtonWrapper>
    //     <MoreButton
    //       onClick={handleProduct}
    //     >더 알아보기</MoreButton>
    //   </MoreButtonWrapper>
    // </Container>
    <Container>
      {/* <Title className="top">신경쓸 것 많은 <br/> 당신에게 필수!<br/> 손쉬운 사진 관리 패키지</Title> */}
      <Title className="top">인화구독,
        <br/>이렇게 구성되어 있어요
      </Title>
      <BodyImg>
        <Img src="/images/newLanding/home/product.png"/>
      </BodyImg>
      <Title className="bottom">
        신경 써야 할  <br/>모든 걸 한 번에</Title>
      <SmallText>앨범, 속지, 인화까지 최고만을 드려요.<br/>구독 시작 시 앨범을,<br/> 매달 사진과 속지를 드려요.</SmallText>
      <MoreButtonWrapper>
        <MoreButton
          onClick={handleProduct}
        >더 알아보기</MoreButton>
      </MoreButtonWrapper>
    </Container>
  )
};

export default Fifth;

const Container = styled.div`
  width: 100%;
  /* min-height: 200vh; */
  background-color: #faf3e2;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  
  
  &.top{
    height: 50px;
    display: flex;
    margin: 50px auto 30px;
    text-align: center;
  }

  &.bottom {
    margin: 50px 20px 0px;
  }
`;

const BodyImg = styled.div`
  width: 100%;
`

const Img= styled.img`
  width: 100%;
`;

const SmallText = styled.div`
  font-size: 16px;
  margin: 30px 20px 50px;
  line-height: 1.4;
`;

const MoreButtonWrapper= styled.div`
  margin: 0 auto 120px;
  width: 40%;
  height: 50px;
`

const MoreButton = styled.button`
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: black;
  background-color: rgb(0,0,0,0);
  border: 1px solid rgb(0,0,0,0.2);
  border-radius: 5px;
`;

